import type { TikTokSANState } from './TikTokSAN.types';

export const INIT_STATE: TikTokSANState = {
  adAccountStatuses: {},
  authenticationUrl: '',
  loading: false,
  advertisers: [],
};
